export default "__VITE_ASSET__97bdtjbD__"